/**
 * mockMode — modo "red simulada" para demostraciones comerciales.
 *
 * Con el modo activado, los reguladores que todavía no publican datos MQTT
 * reales se muestran como conectados y operativos (en vez de "desconectado"),
 * para enseñar cómo se vería el dashboard con toda la flota integrada.
 *
 * Los reguladores con datos MQTT reales no se ven afectados: siguen mostrando
 * su estado real.
 */
import { create } from 'zustand';

interface MockModeState {
  enabled: boolean;
  toggle: () => void;
}

export const useMockMode = create<MockModeState>((set) => ({
  enabled: false,
  toggle: () => set(s => ({ enabled: !s.enabled })),
}));
